import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { LoginService } from '../../../shared/services/login.service';
import { FeeService } from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { WorkrequestChmViewmodel } from '../workrequest-chm-viewmodel';
import { WorkrequestChmDetails } from '../workrequest-chm-details';
import { Subscription } from 'rxjs';
import { AddressService } from '../../../shared/services/address.service';

@Component({
  selector: 'app-workrequest-chm',
  templateUrl: './workrequest-chm.component.html',
  styleUrls: ['./workrequest-chm.component.css']
})
export class WorkrequestChmComponent implements OnInit, OnDestroy {
  @Input()
  isReadOnly = false;
  @Input()
  workRequestViewModel: WorkrequestChmViewmodel;
  @Output()
  onViewModelChange: EventEmitter<WorkrequestChmViewmodel>;
  @Output()
  onFeeCodesReceived: EventEmitter<void>;

  numberOfWaterMetersControl: FormControl;
  numberOfRemoteWaterMetersControl: FormControl;
  existingMeterDetailsControl: FormControl;
  commonWaterUseYesControl: FormControl;
  commonWaterUseNoControl: FormControl;
  commonWaterUseDetailsControl: FormControl;
  bodyCorporateYesControl: FormControl;
  bodyCorporateNoControl: FormControl;
  residentialNoCommonWaterControl: FormControl;
  commercialNoCommonWaterControl: FormControl;
  residentialWithCommonWaterControl: FormControl;
  commercialWithCommonWaterControl: FormControl;
  newCheckMeterLocationControl: FormControl;
  newCheckMeterLocationControlMaxLength = 400;
  commonWaterUseControlMaxLength = 150;
  existingMeterDetailsControlMaxLength = 150;
  maximumMeters = 2000;
  numberRegEx = /^[0-9]*$/;

  feeControlGroup: FormGroup;
  developmentTypeControlGroup: FormGroup;
  commonWaterControlGroup: FormGroup;
  bodyCorpControlGroup: FormGroup;

  pricingZone: string = SERVICE_PROVIDER.CWW;
  $subs: Subscription;

  constructor(private loginService: LoginService, private feeService: FeeService, private addressService: AddressService) {

    if (!this.workRequestViewModel) {
      this.workRequestViewModel = new WorkrequestChmViewmodel();
    }
    if (!this.workRequestViewModel.workrequestDetails) {
      this.workRequestViewModel.workrequestDetails = new WorkrequestChmDetails();
    }

    this.onFeeCodesReceived = new EventEmitter();
    this.numberOfWaterMetersControl = new FormControl('', [Validators.compose([Validators.min(0),
    Validators.max(this.maximumMeters), Validators.pattern(this.numberRegEx)])]);
    this.numberOfRemoteWaterMetersControl = new FormControl('', [Validators.compose([Validators.min(0),
    Validators.max(this.maximumMeters), Validators.pattern(this.numberRegEx)])]);
    this.existingMeterDetailsControl = new FormControl('',
      [Validators.compose([Validators.maxLength(this.existingMeterDetailsControlMaxLength)])]);
    this.commonWaterUseYesControl = new FormControl();
    this.commonWaterUseNoControl = new FormControl();
    this.commonWaterUseDetailsControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.commonWaterUseControlMaxLength)
    ])]);
    this.bodyCorporateYesControl = new FormControl();
    this.bodyCorporateNoControl = new FormControl();
    this.residentialNoCommonWaterControl = new FormControl();
    this.commercialNoCommonWaterControl = new FormControl();
    this.residentialWithCommonWaterControl = new FormControl();
    this.commercialWithCommonWaterControl = new FormControl();
    this.newCheckMeterLocationControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.newCheckMeterLocationControlMaxLength)
    ])]);

    this.feeControlGroup = new FormGroup({
      numberOfWaterMeters: this.numberOfWaterMetersControl,
      numberOfRemoteWaterMeter: this.numberOfRemoteWaterMetersControl
    }, (g: FormGroup): ValidationErrors => {
      return { greaterThanZero: (g.controls.numberOfRemoteWaterMeter.value + g.controls.numberOfWaterMeters.value) <= 0 };
    });

    this.developmentTypeControlGroup = new FormGroup({
      resNoCommon: this.residentialNoCommonWaterControl,
      resWithCommon: this.residentialWithCommonWaterControl,
      commercialNoCommon: this.commercialNoCommonWaterControl,
      commercialWithCommon: this.commercialWithCommonWaterControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        oneOf: (!(g.controls.resNoCommon.value || g.controls.resWithCommon.value
          || g.controls.commercialNoCommon.value || g.controls.commercialWithCommon.value))
      };
    });

    this.commonWaterControlGroup = new FormGroup({
      yes: this.commonWaterUseYesControl,
      no: this.commonWaterUseNoControl,
      details: this.commonWaterUseDetailsControl,
    }, (g: FormGroup): ValidationErrors => {
      return {
        oneOf: (!(g.controls.yes.value || g.controls.no.value)),
        details: (g.controls.yes.value && !g.controls.details.value)
      };
    });

    this.bodyCorpControlGroup = new FormGroup({
      yes: this.bodyCorporateYesControl,
      no: this.bodyCorporateNoControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        oneOf: (!(g.controls.yes.value || g.controls.no.value))
      };
    });
  }

  ngOnInit() {
    this.loadFees();

    this.$subs = this.addressService.getPricingZone().subscribe(_pricingZone => {
      this.pricingZone = _pricingZone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);

      // load fees again after pricing zone is updated
      this.loadFees();
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnDestroy() {
    this.$subs.unsubscribe();
  }

  private loadFees() {
    this.feeService.retrieveFees('SimplePlumbing', this.loginService.getToken(),
      this.retrieveFeesOkCb.bind(this),
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  retrieveFeesOkCb(ok: boolean): void {
    if (ok) {
      this.workRequestViewModel.applicationFeeAmount = this.feeService.getCHMApplicationFeeAmount(this.pricingZone);
      this.workRequestViewModel.finalTotal = this.feeService.getCHMApplicationFeeAmount(this.pricingZone);
      this.workRequestViewModel.waterMeterFeeAmount = this.feeService.getWaterMeterFeeAmount(this.pricingZone);
      this.workRequestViewModel.remoteWaterMeterFeeAmount = this.feeService.getRemoteWaterMeterFeeAmount(this.pricingZone);
      this.workRequestViewModel.workrequestDetails.totalOrderAmount = this.workRequestViewModel.applicationFeeAmount;
      this.onFeeCodesReceived.emit();
      this.workRequestViewModel.calculateTotal();
    } else {
      console.log('no fees found');
    }
  }

  get invalid(): boolean {
    if (!this.isValidSelection) {
      return false;
    }

    if (this.newCheckMeterLocationControl.invalid) {
      return false;
    }
  }

  get numberOfWaterMeters(): number {
    return this.workRequestViewModel.workrequestDetails.numberOfWaterMeters;
  }

  set numberOfWaterMeters(v: number) {
    this.workRequestViewModel.workrequestDetails.numberOfWaterMeters = v;
    this.workRequestViewModel.calculateTotal();
  }

  get numberOfRemoteWaterMeters(): number {
    return this.workRequestViewModel.workrequestDetails.numberOfRemoteWaterMeters;
  }

  set numberOfRemoteWaterMeters(v: number) {
    this.workRequestViewModel.workrequestDetails.numberOfRemoteWaterMeters = v;
    this.workRequestViewModel.calculateTotal();
  }

  get existingMeterDetails(): string {
    return this.workRequestViewModel.workrequestDetails.existingMeterDetails;
  }

  set existingMeterDetails(v: string) {
    this.workRequestViewModel.workrequestDetails.existingMeterDetails = v;
  }

  get commonWaterUseYes(): boolean {
    return this.workRequestViewModel.commonWaterUseYes;
  }

  set commonWaterUseYes(v: boolean) {

    this.workRequestViewModel.commonWaterUseYes = v;
  }

  get commonWaterUseNo(): boolean {
    return this.workRequestViewModel.commonWaterUseNo;
  }

  set commonWaterUseNo(v: boolean) {
    this.workRequestViewModel.commonWaterUseNo = v;
  }

  get commonWaterUseDetails(): string {
    return this.workRequestViewModel.workrequestDetails.commonWaterUseDetails;
  }

  set commonWaterUseDetails(v: string) {
    this.workRequestViewModel.workrequestDetails.commonWaterUseDetails = v;
  }

  get bodyCorporateYes(): boolean {
    return this.workRequestViewModel.bodyCorporateYes;
  }

  set bodyCorporateYes(v: boolean) {
    this.workRequestViewModel.bodyCorporateYes = v;
  }

  get bodyCorporateNo(): boolean {
    return this.workRequestViewModel.bodyCorporateNo;
  }

  set bodyCorporateNo(v: boolean) {
    this.workRequestViewModel.bodyCorporateNo = v;
  }

  get residentialNoCommonWater(): boolean {
    return this.workRequestViewModel.residentialNoCommonWater;
  }

  set residentialNoCommonWater(v: boolean) {
    this.workRequestViewModel.residentialNoCommonWater = v;
  }

  get commercialNoCommonWater(): boolean {
    return this.workRequestViewModel.commercialNoCommonWater;
  }

  set commercialNoCommonWater(v: boolean) {
    this.workRequestViewModel.commercialNoCommonWater = v;
  }

  get residentialWithCommonWater(): boolean {
    return this.workRequestViewModel.residentialWithCommonWater;
  }

  set residentialWithCommonWater(v: boolean) {
    this.workRequestViewModel.residentialWithCommonWater = v;
  }

  get commercialWithCommonWater(): boolean {
    return this.workRequestViewModel.commercialWithCommonWater;
  }

  set commercialWithCommonWater(v: boolean) {
    this.workRequestViewModel.commercialWithCommonWater = v;
  }

  get waterMetersAmount(): number {
    return this.workRequestViewModel.waterMetersAmount;
  }

  get remoteWaterMetersAmount(): number {
    return this.workRequestViewModel.remoteWaterMetersAmount;
  }

  get applicationFeeAmount(): number {
    return this.workRequestViewModel.applicationFeeAmount;
  }

  get waterMeterFeeAmount(): number {
    return this.workRequestViewModel.waterMeterFeeAmount;
  }

  get remoteWaterMeterFeeAmount(): number {
    return this.workRequestViewModel.remoteWaterMeterFeeAmount;
  }

  get finalTotal(): number {
    return this.workRequestViewModel.finalTotal;
  }

  get totalOrderAmount(): number {
    return this.workRequestViewModel.workrequestDetails.totalOrderAmount;
  }

  get applicationDate(): string {
    return this.workRequestViewModel.applicationDate;
  }

  get isValidSelection(): boolean {
    return !this.workRequestViewModel.invalidMeterSelection;
  }

  get invalidSelectionError(): string {
    return this.workRequestViewModel.invalidSelectionError;
  }

  get invalidDevelopmentTypeSelection(): boolean {
    return this.workRequestViewModel.invalidDevelopmentTypeSelection;
  }

  get invalidDevelopmentTypeError(): string {
    return this.workRequestViewModel.invalidDevelopmentTypeError;
  }

  get errorMessage(): string {
    return this.workRequestViewModel.errorMessage;
  }

  set errorMessage(v: string) {
    this.workRequestViewModel.errorMessage = v;
  }

  displayErrorMessage(): string {
    this.markValidationControlsAsTouched();
    this.markValidationControlGroupsAsTouched();

    this.errorMessage = null;

    let errorText = '';

    if (!this.isValidSelection) {
      errorText += this.invalidSelectionError + '<br>';
    }

    if (this.invalidDevelopmentTypeSelection) {
      errorText += this.invalidDevelopmentTypeError + '<br>';
    }

    if (this.commonWaterControlGroup.hasError('details')) {
      errorText += 'Please provide the details of any common water use at the property' + '<br>';
    }

    if (this.existingMeterDetailsControl.hasError('maxlength')) {
      errorText += 'Existing/main boundary water meter details description cannot exceed ' +
        this.existingMeterDetailsControlMaxLength + ' characters' + '<br>';
    }

    if (this.commonWaterUseDetailsControl.hasError('maxlength')) {
      errorText += 'Common water use details description cannot exceed ' +
        this.commonWaterUseControlMaxLength + ' characters' + '<br>';
    }

    if (this.bodyCorpControlGroup.hasError('oneOf')) {
      errorText += 'Please select yes or no to does a body corporate exist question' + '<br>';
    }

    if (this.commonWaterControlGroup.hasError('oneOf')) {
      errorText += 'Please select yes or no to any common water use at the property question' + '<br>';
    }

    if (this.newCheckMeterLocationControl.invalid) {
      if (this.newCheckMeterLocationControl.hasError('maxlength')) {
        errorText += 'Meter location description cannot exceed ' + this.newCheckMeterLocationControlMaxLength + ' characters' + '<br>';
      }
      if (this.newCheckMeterLocationControl.hasError('required')) {
        errorText += 'Please advise where check meters will be located' + '<br>';
      }
    }

    this.markValidationControlsAsUntouched();
    this.markValidationControlGroupsAsUntouched();
    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsTouched() {
    this.numberOfWaterMetersControl.markAsTouched();
    this.numberOfRemoteWaterMetersControl.markAsTouched();
    this.existingMeterDetailsControl.markAsTouched();
    this.commonWaterUseYesControl.markAsTouched();
    this.commonWaterUseNoControl.markAsTouched();
    this.commonWaterUseDetailsControl.markAsTouched();
    this.bodyCorporateYesControl.markAsTouched();
    this.bodyCorporateNoControl.markAsTouched();
    this.residentialNoCommonWaterControl.markAsTouched();
    this.commercialNoCommonWaterControl.markAsTouched();
    this.residentialWithCommonWaterControl.markAsTouched();
    this.commercialWithCommonWaterControl.markAsTouched();
    this.newCheckMeterLocationControl.markAsTouched();
  }

  markValidationControlsAsUntouched() {
    this.numberOfWaterMetersControl.markAsUntouched();
    this.numberOfRemoteWaterMetersControl.markAsUntouched();
    this.existingMeterDetailsControl.markAsUntouched();
    this.commonWaterUseYesControl.markAsUntouched();
    this.commonWaterUseNoControl.markAsUntouched();
    this.commonWaterUseDetailsControl.markAsUntouched();
    this.bodyCorporateYesControl.markAsUntouched();
    this.bodyCorporateNoControl.markAsUntouched();
    this.residentialNoCommonWaterControl.markAsUntouched();
    this.commercialNoCommonWaterControl.markAsUntouched();
    this.residentialWithCommonWaterControl.markAsUntouched();
    this.commercialWithCommonWaterControl.markAsUntouched();
    this.newCheckMeterLocationControl.markAsUntouched();
    this.loadFees();
  }

  markValidationControlGroupsAsTouched() {
    this.feeControlGroup.markAsTouched();
    this.developmentTypeControlGroup.markAsTouched();
    this.commonWaterControlGroup.markAsTouched();
    this.bodyCorpControlGroup.markAsTouched();
  }

  markValidationControlGroupsAsUntouched() {
    this.feeControlGroup.markAsUntouched();
    this.developmentTypeControlGroup.markAsUntouched();
    this.commonWaterControlGroup.markAsUntouched();
    this.bodyCorpControlGroup.markAsUntouched();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/chm-form/workrequest-chm/workrequest-chm.component.ts